import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Blurb from './components/Blurb';
import Clouds from './images/clouds.png';
import ArticleGrid from "./components/ArticleGrid";
import Landing from "./components/Landing";
import { mediaQueries } from "./shared/config";
import {isMobile} from 'react-device-detect';
import BlurbTwo from "./components/Blurb2";

import MobileGrid from "./components/MobileGrid";

const GradientBackground = styled.div`
  position: absolute;
  width: 100%;
  height: auto;
  background: linear-gradient(to bottom, #FFFCB5, #FFC7B5, #A783D6);
  z-index: -1;
`

const Background = styled.div`
  width: 100%;
  height: 382.625em;
  background: url(${Clouds}) center/cover;
`

// const Background = styled.div`
//   width: 100%;
//   height: 382.625em;
//   /*background-image: linear-gradient(to bottom, #D2CF8E, #FFDACE, #9e7ec7);*/
//   background: url(${Clouds}) center/cover, linear-gradient(to bottom, #FFFCB5, #FFC7B5, #A783D6);;
// `

const Container = styled.div`
  background-color: #C398CC;
`

function App() {
  const [ data, setData ] = useState(null);
  const [isMobileDevice, setIsMobileDevice] = useState(isMobile)
  useEffect(() => {
    setIsMobileDevice(isMobile);
  }, []);

  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/spring-sing-2024")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  if(isMobile){
  return data && (
    <div className="App">
      <Header/>
      <GradientBackground>
      <Landing data={data}></Landing>
      <Background>
      <Blurb blurb_text={data.blurb[0].blurb_text}/>
      <MobileGrid articles={data.articles} />
      {/* <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <BlurbTwo props={data.blurb[1]}/> */}
      </Background>
      <Footer/>
      </GradientBackground>
      
    </div>
  );
}
else{
  return data && (
    <div className="App">
      <Header/>
      <GradientBackground>
      <Landing data={data}></Landing>
      <Blurb blurb_text={data.blurb[0].blurb_text}/>
      <Background>
     <br /><br /><br /><br /><br /><br />

      <ArticleGrid props={data.articles}></ArticleGrid>
      {/* <BlurbTwo props={data.blurb[1]}/> */}
      </Background>
      <Footer/>
      </GradientBackground>
      
    </div>
  );
}
}

export default App;
